import { ReactNode } from 'react';
import clsx from 'clsx';
import { Button, Icon } from '@kontentino/ui';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface EmptyStateProps {
  icon?: IconDefinition;
  title: string;
  description?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
    dataCy?: string;
  };
  className?: string;
  dataCy?: string;
}

const EmptyState = ({
  icon,
  title,
  description,
  action,
  className,
  dataCy,
}: EmptyStateProps) => {
  return (
    <div
      className={clsx(
        'tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-y-3 tw-p-8 tw-text-grayscale-100',
        className,
      )}
      data-cy={dataCy}
    >
      {icon && (
        <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-grayscale-10 tw-text-grayscale-100">
          <Icon icon={icon} size="xl" />
        </div>
      )}
      <p className="tw-text-center tw-text-base tw-font-semibold tw-text-grayscale-180">
        {title}
      </p>
      {description && (
        <p className="tw-max-w-md tw-text-center tw-text-md tw-font-regular tw-text-grayscale-140">
          {description}
        </p>
      )}
      {action && (
        <Button
          variant={action.variant ?? 'primary'}
          size="small"
          onClick={action.onClick}
          data-cy={action.dataCy}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
